import { Mail } from "lucide-react";
import { motion } from "framer-motion";

const ContactSection = () => {
    return (
        <div className="relative bg-[#0F0F0F] text-white py-12 px-6 sm:py-16 sm:px-10 md:py-20 md:px-12 lg:px-20 overflow-hidden">
            <div className="max-w-6xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 50, scale: 0.95 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 1, type: "spring", bounce: 0.2 }}
                    className="mt-16 sm:mt-20 bg-[#0B3D2E] backdrop-blur-sm rounded-2xl p-8 sm:p-12 border border-[#2F8F6F]/20"
                >
                    <h3 className="text-4xl font-bold mb-6 text-center">
                        Let's Work <span className="text-[#2F8F6F]">Together</span>
                    </h3>
                    <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto text-center">
                        Ready to bring your ideas to life with modern web technologies.
                        Let's create something amazing together!
                    </p>
                    <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
                        <a
                            href="mailto:rizkimakruf88@gmail.com"
                            className="bg-[#2F8F6F] hover:bg-[#145A43] px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg hover:shadow-[#2F8F6F]/30 inline-flex items-center text-white"
                        >
                            <Mail className="w-5 h-5 mr-2" />
                            Get In Touch
                        </a>
                    </div>
                </motion.div>
            </div>

            <motion.div
                animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
                transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
                className="absolute top-1/4 left-4 sm:left-10 w-56 sm:w-72 h-56 sm:h-72 bg-[#0B3D2E]/15 rounded-full blur-3xl -z-10"
            />
            <motion.div
                animate={{ scale: [1, 1.3, 1], opacity: [0.3, 0.6, 0.3] }}
                transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                className="absolute bottom-1/4 right-4 sm:right-10 w-72 sm:w-96 h-72 sm:h-96 bg-[#145A43]/10 rounded-full blur-3xl -z-10"
            />
        </div>
    );
};

export default ContactSection;